import styles from './Styles.module.scss'
import React, { useMemo } from 'react'

export const Fail = ({ errorCode }) => {
  const isIpOrAck = process.env.REACT_APP_IS_IP_OR_ACK === 'true'

  const url = window.location.href
  const urlOrgin = new URL(url).origin

  const finsovetnik =
    urlOrgin === process.env.REACT_APP_PROD_FA_URL ||
    urlOrgin === process.env.REACT_APP_TEST_FA_URL

  const getText = useMemo(() => {
    if (errorCode === 401) {
      return 'Ошибка авторизации, пожалуйста войдите в свой аккаунт profinansy.ru и повторите попытку'
    }
    return 'Ошибка! Ваш платеж отклонен'
  }, [errorCode])

  return (
    <div className={styles.root} data-testid="root">
      {isIpOrAck ? null : finsovetnik ? (
        <img
          data-testid="fs-logo"
          src="/FSlogo.png"
          alt=""
          className={styles.FSlogo}
        />
      ) : (
        <img
          data-testid="default-logo"
          src="/logo.png"
          alt=""
          className={styles.logo}
        />
      )}

      <div className={styles.failMain} data-testid="sucMain">
        <img
          data-testid="failImg"
          src="/failImg.png"
          alt="failImg"
          className={styles.failImg}
        />

        <div className={styles.title} data-testid="title">
          {getText}
        </div>
        <div className={styles.text} data-testid="text">
          Повторите попытку позже. Если у вас не получилось самостоятельно
          решить проблему,{' '}
          <a
            data-testid="support-link"
            href="https://t.me/profinansy_help_bot"
            className={styles.supportText}
          >
            свяжитесь с нами
          </a>
        </div>
      </div>
    </div>
  )
}
